import * as actionTypes from "./constants";

const fetchCurrentAlerts = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_CURRENT_ALERTS_INIT_ACTION,
    });
  };
};

const fetchApartments = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_APARTMENTS_INIT_ACTION,
    });
  };
};

const fetchSocietyConsumption = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SOCOETY_CONSUMPTION_INIT_ACTION,
      params: params,
    });
  };
};

const fetchPendingBills = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_PENDING_BILL_APARTMENT_INIT_ACTION,
    });
  };
};

const fetchBillDetails = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_BILL_DETAILS_INIT_ACTION,
    });
  };
};

const fetchTotalCommercialWater = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_COMMERCIAL_WATER_INIT_ACTION,
      params: params,
    });
  };
};

const fetchTotalMunicipalWater = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_MUNICIPAL_WATER_INIT_ACTION,
      params: params,
    });
  };
};

const fetchTotalGroundWater = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_GROUND_WATER_INIT_ACTION,
      params: params,
    });
  };
};

const fetchTotalRainWater = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_RAIN_WATER_INIT_ACTION,
      params: params,
    });
  };
};

const fetchSlabRateTotal = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SLAB_RATE_INIT_ACTION,
    });
  };
};
const saveCurrentDate = (param) => {
  return (dispatch) => {
    dispatch({
      type: "SAVE_CURRENT_DATE",
      param: param,
    });
  };
};

const addPrimaryRwaMember = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_PRIMARY_RWAMEMBER_INIT_ACTION,
      value: value,
    });
  };
};

const cleardashboarddata = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_DASHBOARD_REDUCER",
    });
  };
};

const fetchAggregateConsumption = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION,
      value: value,
    });
  };
};

export const getWaterSourceData = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_WATER_SOURCE_DATA_INIT_ACTION,
      value: value,
    });
  };
};

export default {
  fetchCurrentAlerts,
  fetchApartments,
  fetchSocietyConsumption,
  fetchPendingBills,
  fetchBillDetails,
  fetchTotalCommercialWater,
  fetchTotalMunicipalWater,
  fetchTotalGroundWater,
  fetchTotalRainWater,
  fetchSlabRateTotal,
  saveCurrentDate,
  addPrimaryRwaMember,
  cleardashboarddata,
  fetchAggregateConsumption,
  getWaterSourceData,
};
